import { render, staticRenderFns } from "./StudentScheduleItem.vue?vue&type=template&id=56f4f3a4&scoped=true&"
import script from "./StudentScheduleItem.vue?vue&type=script&lang=js&"
export * from "./StudentScheduleItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentScheduleItem.vue?vue&type=style&index=0&id=56f4f3a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4f3a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VIcon,VTooltip})
